import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { useAtomValue } from 'jotai';
import { inspectionPortalQueryKeys } from '../pages/inspection-portal/query-keys';
import {
  type IInspectionPortalService,
  InspectionPortalService,
} from '../services/inspection/inspection-portal.service';
import { inspectionSessionAtom } from '../stores/inspection-session.store';

export function useInspectionQrIconName(uuid: string | null) {
  const service = useInjection<IInspectionPortalService>(InspectionPortalService);
  const session = useAtomValue(inspectionSessionAtom);
  const { data: iconName = null, isLoading } = useQuery({
    queryKey: inspectionPortalQueryKeys.qrIcon(uuid, session?.sourceToken),
    queryFn: () => service.getQrIconName(uuid as string).then((r) => r.iconName),
    enabled: uuid !== null && Boolean(session),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
  });

  return { iconName, isLoading };
}
